/* @flow */
const prefix = str => `station/global-whitelist/${str}`;

export const UPDATE_PAGE_FILTERS = prefix('UPDATE_PAGE_FILTERS');
export const RESET_PAGE_FILTERS = prefix('RESET_PAGE_FILTERS');

export const FETCH_WHITELIST_PAGE = prefix('FETCH_WHITELIST_PAGE');
export const FETCH_WHITELIST_PAGE_SUCCESS = prefix('FETCH_WHITELIST_PAGE_SUCCESS');
export const FETCH_WHITELIST_PAGE_FAILURE = prefix('FETCH_WHITELIST_PAGE_FAILURE');

export const SAVE_WHITELIST_ENTRY = prefix('SAVE_WHITELIST_ENTRY');
export const SAVE_WHITELIST_ENTRY_SUCCESS = prefix('SAVE_WHITELIST_ENTRY_SUCCESS');
export const SAVE_WHITELIST_ENTRY_FAILURE = prefix('SAVE_WHITELIST_ENTRY_FAILURE');

export const SAVE_WHITELIST_ENTRIES = prefix('SAVE_WHITELIST_ENTRIES');
export const SAVE_WHITELIST_ENTRIES_SUCCESS = prefix('SAVE_WHITELIST_ENTRIES_SUCCESS');
export const SAVE_WHITELIST_ENTRIES_FAILURE = prefix('SAVE_WHITELIST_ENTRIES_FAILURE');

export const DELETE_WHITELIST_ENTRY = prefix('DELETE_WHITELIST_ENTRY');
export const DELETE_WHITELIST_ENTRY_SUCCESS = prefix('DELETE_WHITELIST_ENTRY_SUCCESS');
export const DELETE_WHITELIST_ENTRY_FAILURE = prefix('DELETE_WHITELIST_ENTRY_FAILURE');

export const CLEAR_WHITELIST = prefix('CLEAR_WHITELIST');
export const CLEAR_WHITELIST_SUCCESS = prefix('CLEAR_WHITELIST_SUCCESS');
export const CLEAR_WHITELIST_FAILURE = prefix('CLEAR_WHITELIST_FAILURE');


// WEBPACK FOOTER //
// ./src/app/modules/global-whitelist/action-types.js